import React, { useState } from 'react';
import {
  Button,
  FormControlLabel,
  Checkbox,
  Box,
  Typography,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import BaseDialog from './BaseDialog';

interface CreateGotyDialogProps {
  open: boolean;
  onClose: () => void;
}

const CreateGotyDialog: React.FC<CreateGotyDialogProps> = ({ open, onClose }) => {
  const navigate = useNavigate();
  const currentYear = new Date().getFullYear();

  const [year, setYear] = useState<number>(currentYear);
  const [isMyGoty, setIsMyGoty] = useState<boolean>(false);

  const handleCreate = () => {
    // MyGOTYかどうかでURLパスを分ける
    const path = isMyGoty ? `/mygoty/${year}/edit` : `/goty/${year}/edit`;
    navigate(path);
    onClose();
  };

  const handleClose = () => {
    // ダイアログを閉じる際にリセット
    setYear(currentYear);
    setIsMyGoty(false);
    onClose();
  };

  return (
    <BaseDialog
      open={open}
      onClose={handleClose}
      title="新規GOTY作成"
      actions={
        <>
          <Button onClick={handleClose}>キャンセル</Button>
          <Button onClick={handleCreate} variant="contained">
            作成
          </Button>
        </>
      }
    >
      <Box sx={{ pt: 1 }}>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          同じ年にGOTYとMyGOTYの両方を作成できます
        </Typography>

        <FormControl fullWidth sx={{ mb: 2 }}>
          <InputLabel>年</InputLabel>
          <Select
            value={year}
            label="年"
            onChange={(e) => setYear(e.target.value as number)}
          >
            <MenuItem value={2024}>2024</MenuItem>
            <MenuItem value={2025}>2025</MenuItem>
          </Select>
        </FormControl>

        <Box sx={{
          p: 2,
          borderRadius: 1,
          backgroundColor: 'rgba(255, 255, 255, 0.03)',
          border: '1px solid rgba(255, 255, 255, 0.08)',
          mb: 3
        }}>
          <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 600 }}>
            GOTY（通常）
          </Typography>
          <Typography variant="caption" color="text.secondary">
            前年12月～今年11月末までに発売されたゲームが対象
          </Typography>
        </Box>

        <FormControlLabel
          control={
            <Checkbox
              checked={isMyGoty}
              onChange={(e) => setIsMyGoty(e.target.checked)}
            />
          }
          label={
            <Box>
              <Typography variant="body2">MyGOTY（発売年の制約なし）</Typography>
              <Typography variant="caption" color="text.secondary">
                その年に遊んだゲームを発売日に関わらず選択できます
              </Typography>
            </Box>
          }
        />
      </Box>
    </BaseDialog>
  );
};

export default CreateGotyDialog;
